// مفاتيح أجزاء البودي المعروفة في رسم السيارة (BodyDamageDiagram).
// أي مفتاح خارج هذه القائمة لن يجد جزءًا في الرسم، وأي مفتاح مكتوب خطأ
// يضع نتيجة الجزء على جزء آخر في التقرير، لذلك تُختار من قائمة لا تُكتب يدويًا.
export const BODY_ZONE_KEY_OPTIONS = [
  { value: 'front_bumper', label: 'الصدام الأمامي' },
  { value: 'rear_bumper', label: 'الصدام الخلفي' },
  { value: 'hood', label: 'غطاء المحرك (الكبوت)' },
  { value: 'roof', label: 'السقف' },
  { value: 'front_windshield', label: 'الزجاج الأمامي' },
  { value: 'rear_windshield', label: 'الزجاج الخلفي' },
  { value: 'trunk', label: 'غطاء الصندوق الخلفي — سيدان / SUV' },
  { value: 'rear_hatch', label: 'الباب الخلفي المرفوع — هاتشباك' },
  { value: 'tailgate', label: 'باب الحوض الخلفي — بيك أب / فان' },
  { value: 'rear_chassis', label: 'الشاسيه الخلفي — شاسي كاب' },
  { value: 'rear_box', label: 'الصندوق الخلفي — شاحنة صندوق' },
  { value: 'right_front_fender', label: 'الرفرف الأمامي الأيمن' },
  { value: 'right_front_door', label: 'الباب الأمامي الأيمن' },
  { value: 'right_rear_door', label: 'الباب الخلفي الأيمن' },
  { value: 'right_rear_fender', label: 'الرفرف الخلفي الأيمن' },
  { value: 'right_side_panel', label: 'الجنب الخلفي الأيمن' },
  { value: 'left_front_fender', label: 'الرفرف الأمامي الأيسر' },
  { value: 'left_front_door', label: 'الباب الأمامي الأيسر' },
  { value: 'left_rear_door', label: 'الباب الخلفي الأيسر' },
  { value: 'left_rear_fender', label: 'الرفرف الخلفي الأيسر' },
  { value: 'left_side_panel', label: 'الجنب الخلفي الأيسر' },
];

export function bodyZoneKeyLabel(zoneKey) {
  if (!zoneKey) return '';
  const match = BODY_ZONE_KEY_OPTIONS.find((option) => option.value === zoneKey);
  return match ? match.label : zoneKey;
}
